import React, { Component } from "react";

export class Imagerow extends Component {
  render() {
    return (
      <>
          <div className="image">
            {
              this.props.fullimage ? 
              <a data-fancybox="gallery" href={this.props.fullimage} >
                <img src={this.props.images} alt="" />
              </a>
              :
              <a data-fancybox="gallery" href={this.props.images}>
                <img src={this.props.images} alt="" />
              </a>
            }
          </div>
      </>
    );
  }
}

export default Imagerow;
